import React from 'react';
import { Badge, SeverityBadge, StatusBadge } from '@/components/primitives';

/*
 * A static, clearly labelled example of the Inbox: a short queue and the
 * open brief, drawn with the same badges the product uses. The content is
 * written for illustration and is never presented as live data.
 */
const QUEUE = [
  { sev: 'High', status: 'new', name: 'Phishing kit abusing file-sharing links', current: true },
  { sev: 'Critical', status: 'triage', name: 'Exploited VPN appliance vulnerability' },
  { sev: 'Medium', status: 'acked', name: 'Loader spread through fake browser updates' },
];

const TECHNIQUES = ['T1566.002 Spearphishing Link', 'T1539 Steal Web Session Cookie'];

const SIGMA_EXCERPT = `title: Sign-in after link from file-sharing domain
logsource: { product: azure, service: signinlogs }
detection:
  selection: { RiskLevelDuringSignIn: high }
  condition: selection`;

export default function WelcomeExampleBrief() {
  return (
    <figure className="wl-example" style={{ margin: 0 }} aria-labelledby="wl-example-caption">
      <div className="wl-example-bar">
        <span className="t-label">Inbox</span>
        <span style={{ flex: 1 }} />
        <Badge tone="warning">Example</Badge>
      </div>

      <div className="wl-example-body">
        <ul className="wl-example-queue" aria-label="Example queue" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {QUEUE.map((q) => (
            <li key={q.name} className="wl-example-row" aria-current={q.current ? 'true' : undefined}>
              <span className="bar" style={{ background: `var(--state-${q.sev.toLowerCase()})` }} aria-hidden="true" />
              <div style={{ minWidth: 0 }}>
                <div className="chips">
                  <SeverityBadge severity={q.sev} size="sm" short />
                  <StatusBadge status={q.status} size="sm" />
                </div>
                <div className="name">{q.name}</div>
              </div>
            </li>
          ))}
        </ul>

        <div className="wl-example-doc">
          <div className="t-meta">
            <span>Brief · Example</span>
            <span aria-hidden="true">·</span>
            <span>3 sources merged</span>
          </div>
          <h3>Phishing kit abusing file-sharing links to steal SaaS sessions</h3>
          <p>
            Three outlets covered the same campaign; they are merged into this one brief and
            matched to the profile <strong style={{ color: 'var(--text-primary)', fontWeight: 600 }}>Technology · Europe · SIEM, EDR</strong>.
          </p>

          <div className="wl-example-section">
            <div className="t-label">MITRE ATT&amp;CK</div>
            <div className="wl-example-tags">
              {TECHNIQUES.map((t) => <Badge key={t} tone="accent" size="sm">{t}</Badge>)}
            </div>
          </div>

          <div className="wl-example-section">
            <div className="t-label">Sigma rule · excerpt</div>
            <pre className="wl-example-code">{SIGMA_EXCERPT}</pre>
          </div>
        </div>
      </div>

      <figcaption id="wl-example-caption" className="wl-example-caption" style={{ padding: '0 16px 14px' }}>
        Example written for illustration. Your Inbox shows real stories matched to your profile.
      </figcaption>
    </figure>
  );
}
